@if (promoCodesModalData) {
  <div class="c-promoCodesModal">
    <div class="c-promoCodesModal__title">
      <span>{{ 'home.lobby.modals.promo-code.title' | translate }}</span>
    </div>
    <div class="c-promoCodesModal__subtitle">
      <span>{{ 'home.lobby.modals.promo-code.subtitle' | translate }}</span>
      <span>{{ 'home.lobby.modals.promo-code.message' | translate }}</span>
    </div>
    <div class="c-promoCodesModal__reward">
      <span>{{ promoCodesModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
    </div>
    <slotcom-button
      class="c-button--pink"
      (safeClick)="redeemBonus()"
      audioType="reward">
      {{ 'home.buttons.collect' | translate | uppercase }}
    </slotcom-button>
  </div>
}
